import type { RouteRecordRaw } from 'vue-router'

import { AppRoute } from '@/constants'
import { ModuleAccess } from '@/constants/rights'

export const ProcessTaskRoutes: RouteRecordRaw[] = [
  {
    path: AppRoute.ProcessTask.path,
    name: AppRoute.ProcessTask.name,
    component: () => import('@/modules/process-task/Index.vue'),
    meta: {
      requiresAuth: true,
      authorities: [ModuleAccess],
    },
  },
  {
    path: AppRoute.ProcessTask.Page.path,
    name: AppRoute.ProcessTask.Page.name,
    component: () => import('@/modules/process-task/page/Index.vue'),
    redirect: { name: AppRoute.ProcessTask.Page.Main.name },
    props: true,
    meta: {
      requiresAuth: true,
      authorities: [ModuleAccess],
    },
    children: [
      {
        path: AppRoute.ProcessTask.Page.Main.path,
        name: AppRoute.ProcessTask.Page.Main.name,
        component: () => import('@/modules/process-task/page/MainInfo.vue'),
      },
      {
        path: AppRoute.ProcessTask.Page.Process.path,
        name: AppRoute.ProcessTask.Page.Process.name,
        component: () => import('@/modules/process-task/page/VersionInfo.vue'),
      },
    ],
  },
]
